export default __webpack_public_path__ + "static/media/1919.1fc814a0.png";